export const ABOUT_ME_MAX_LENGTH = 1000;
export const MAX_WORKSTYLES_POINTS = 21;
export const MAX_WORKSTYLES_POINTS_FOR_EACH = 6;
